import PropTypes from 'prop-types';
import {greyishBlue50} from "assets/jss/main";

FoldableContent.propTypes = {
    open: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

function FoldableContent({open = false, children}) {
    return (
        <div
            style={{
                overflow: "hidden",
                maxHeight: open ? "1000px" : "0px",
                opacity: open ? 1 : 0,
                transition: "max-height 0.3s ease, opacity 0.25s ease",
            }}
        >
            <div
                style={{
                    padding: "0 20px 20px 20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    borderTop: `1px solid ${greyishBlue50}`,
                }}
            >
                <div style={{paddingTop: "16px"}}>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default FoldableContent;
